"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLogger = void 0;
exports.defaultLogger = {
    warn: (message, meta) => {
        console.warn(`[WARN] ${message}`, meta);
    },
    error: (message, meta) => {
        console.error(`[ERROR] ${message}`, meta);
    },
    info: (message, meta) => {
        console.info(`[INFO] ${message}`, meta);
    }
};
//# sourceMappingURL=logger.js.map